"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointHoverArea = exports.LineChart = void 0;

var _palette = require("@artsy/palette");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ChartHoverTooltip = require("../DataVis/ChartHoverTooltip");

var _ChartTooltip = require("../DataVis/ChartTooltip");

var _MousePositionContext = require("../DataVis/MousePositionContext");

var _useWrapperWidth = require("../DataVis/utils/useWrapperWidth");

var _LineChartSVG = require("./LineChartSVG");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var margin = (0, _palette.space)(2);
var DEFAULT_HEIGHT = 87;

/**
 * LineChart is a component that displays some data points connected by lines.
 * Useful for visualizing a time series, etc.
 */
var LineChart = function LineChart(_ref) {
  var points = _ref.points,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? DEFAULT_HEIGHT : _ref$height;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      hoverIndex = _useState2[0],
      setHoverIndex = _useState2[1];

  var wrapperRef = (0, _react.useRef)(null);
  var width = (0, _useWrapperWidth.useWrapperWidth)(wrapperRef);
  return /*#__PURE__*/_react.default.createElement(_MousePositionContext.ProvideMousePosition, null, /*#__PURE__*/_react.default.createElement(_palette.Flex, {
    flexDirection: "column",
    ref: wrapperRef,
    width: "100%"
  }, width && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_palette.Flex, {
    height: height
  }, points.map(function (point, i) {
    return /*#__PURE__*/_react.default.createElement(HoverHandler, {
      key: i,
      index: i,
      hoverIndex: hoverIndex,
      setHoverIndex: setHoverIndex
    }, (0, _ChartTooltip.coerceTooltip)(point.tooltip));
  })), /*#__PURE__*/_react.default.createElement(_LineChartSVG.LineChartSVG, {
    width: width,
    height: height,
    margin: margin,
    points: points,
    hoverIndex: hoverIndex
  }), points.filter(function (bar) {
    return bar.axisLabelX;
  }).length > 0 && /*#__PURE__*/_react.default.createElement(_palette.Flex, {
    px: "2",
    width: width
  }, points.map(function (_ref2, i) {
    var axisLabelX = _ref2.axisLabelX;
    return /*#__PURE__*/_react.default.createElement(BarAxisLabelContainer, {
      key: i,
      first: i === 0,
      last: i === points.length - 1
    }, /*#__PURE__*/_react.default.createElement(AxisLabelX, {
      color: "black60",
      variant: "xs"
    }, axisLabelX));
  })))));
};

exports.LineChart = LineChart;
LineChart.displayName = "LineChart";

var HoverHandler = function HoverHandler(_ref3) {
  var children = _ref3.children,
      index = _ref3.index,
      hoverIndex = _ref3.hoverIndex,
      setHoverIndex = _ref3.setHoverIndex;
  var hover = hoverIndex === index;
  return /*#__PURE__*/_react.default.createElement(PointHoverArea, {
    onMouseEnter: function onMouseEnter() {
      return setHoverIndex(index);
    },
    onMouseLeave: function onMouseLeave() {
      return setHoverIndex(-1);
    },
    style: {
      opacity: hover ? 1 : 0
    }
  }, hover && /*#__PURE__*/_react.default.createElement(_ChartHoverTooltip.ChartHoverTooltip, null, children));
};

HoverHandler.displayName = "HoverHandler";

/**
 * The rectangle area around Dots which triggers mouseover for tooltip
 */
var PointHoverArea = _styledComponents.default.div.withConfig({
  displayName: "LineChart__PointHoverArea",
  componentId: "sc-5u6zwj-0"
})(["flex:1;z-index:1;margin:0 1%;opacity:0;transition:opacity 0.4s ease-in;"]);

exports.PointHoverArea = PointHoverArea;

var BarAxisLabelContainer = _styledComponents.default.div.withConfig({
  displayName: "LineChart__BarAxisLabelContainer",
  componentId: "sc-5u6zwj-1"
})(["flex:", ";min-height:", "px;position:relative;", ";"], function (_ref4) {
  var last = _ref4.last;
  return last ? 0 : 1;
}, (0, _palette.space)(2), _palette.media.xs(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: ", ";;\n  "])), function (_ref5) {
  var first = _ref5.first,
      last = _ref5.last;
  return first || last ? "auto" : "none";
}));

var AxisLabelX = (0, _styledComponents.default)(_palette.Text).withConfig({
  displayName: "LineChart__AxisLabelX",
  componentId: "sc-5u6zwj-2"
})(["position:absolute;text-align:center;white-space:nowrap;transform:translateX(-33%);"]);
//# sourceMappingURL=LineChart.js.map